import React from 'react';
import { RaceSummaryHorseRacing } from './raceSummarySport/horseRacing/RaceSummaryHorseRacing';
import { RaceSummaryGreyhoundRacing } from './raceSummarySport/greyhoundRacing/RaceSummaryGreyhoundRacing';
import { observer } from 'src/utils/mobx-react';
import { HorseRacingSortOrderType } from 'src/domains/sportsbook/webview/components/raceCard/RaceCompetition.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

interface PropsType {
    marketId: MarketId;
    sortOrder?: HorseRacingSortOrderType;
    isSpecials?: boolean;
    isAntePost?: boolean;
}

export const RaceSummary = observer('RaceSummary', (props: PropsType) => {
    const { isAntePost, isSpecials, marketId, sortOrder } = props;

    const marketModel = marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const sport = eventModel.sport;

    const isHorseRacing = sport === 'horseracing';

    if (isHorseRacing) {
        return (
            <RaceSummaryHorseRacing
                isAntePost={isAntePost}
                isSpecials={isSpecials}
                marketId={marketId}
                sortOrder={sortOrder}
            />
        );
    }

    const isGreyhoundRacing = sport === 'greyhoundracing';

    if (isGreyhoundRacing) {
        return <RaceSummaryGreyhoundRacing marketId={marketId} />;
    }

    return null;
});
